import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Phone as PhoneIcon } from "@mui/icons-material";

import { black, rideStatusLabelColors } from "../../../../../../design-system/colors";
import { StatusCircleFullIcon } from "../../../../../../design-system/icons";
import { getDispatchStatus } from "../../../../../../globals/utils/helpers";
import { useScreenSize } from "../../../../../../globals/hooks";
type GnetFarmOutInfoBlockProps = {
  dispatchStatus: string;
  driverName: string;
  driverNumber?: string;
}

function GnetFarmOutInfoBlock({ 
  dispatchStatus,
  driverName,
  driverNumber 
}: GnetFarmOutInfoBlockProps) {
  const { isMobileView } = useScreenSize();
  const { color, backgroundColor } = rideStatusLabelColors[dispatchStatus];

  return (
    <Box>
      <Box mb={2}>
        <Typography variant="overline">Driver Information</Typography>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography variant="body1" style={{ marginRight: 16 }}>
            {driverName || "Not Assigned"}
          </Typography>
          {driverNumber && (
            <Box display="flex" alignItems="center" color={black}>
              <PhoneIcon sx={{ fontSize: 18, marginRight: 0.5 }} />
              <Typography variant="body2">{driverNumber}</Typography>
            </Box>
          )}
        </Box>
      </Box>

      <Box>
        <Typography variant="overline">Route Status</Typography>
        <Box mt={1}>
          <Button
            style={{
              color,
              backgroundColor,
              justifyContent: "start",
              textTransform: "none",
              cursor: "default"
            }}
            startIcon={<StatusCircleFullIcon color={color} />}
            disableRipple
          >
            {getDispatchStatus(dispatchStatus, {
              shortened: isMobileView
            })}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default GnetFarmOutInfoBlock;
